import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const initialState = {
  userInfo: {},
  reports: [],        
  allReports: [],     
  status: 'idle',
  error: null,
  reportsStatus: 'idle',
  reportError: null,
};

export const fetchUserInfo = createAsyncThunk(
  'super-admin/user',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`super-admin/user/${id}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg);
    }
  }
);

export const fetchUserReports = createAsyncThunk(
  'userInfo/fetchUserReports',
  async ({ id }, { rejectWithValue }) => {
    try {
      const role = getRole();

      // FIELD OFFICER
      if (role === 'FIELD_OFFICER') {
        const { data } = await axiosInstance.get(
          `/field-officer/farmers/reports/${id}`
        );
        return { mode: 'FIELD_OFFICER', data: data.report };
      }

      // SUPPORT
      const { data } = await axiosInstance.get(`super-admin/user-reports/${id}`);
      return { mode: 'SUPPORT', data: data };

    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || err.response?.data);
    }
  }
);

export const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    resetUserInfo(state) {
        state.reports = [];
        state.allReports = [];
        state.reportsStatus = 'idle';
    }
  },
  extraReducers(builder) {
    // User Info 
    builder
      .addCase(fetchUserInfo.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userInfo = { ...action.payload };
      })
      .addCase(fetchUserInfo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occured';
      });

    // Reports
    builder
      .addCase(fetchUserReports.pending, (state) => {
        state.reportsStatus = 'loading';
        state.reportError = null;
      })
      .addCase(fetchUserReports.fulfilled, (state, action) => {
        state.reportsStatus = 'succeeded';
        state.reports = action.payload.data || [];
        state.allReports = action.payload.data || [];
      })
      .addCase(fetchUserReports.rejected, (state, action) => {
        state.reportsStatus = 'failed';
        state.reportError = action.payload || 'An error occured';
      });
  },
});

export const { resetUserInfo } = userSlice.actions;
export default userSlice.reducer;